import { Product } from 'types/products';
import { CategoryKey } from './categories';

export const productsByCategory: Record<CategoryKey, Product[]> = {
  [CategoryKey.BestSellers]: [
    {
      id: 'ed654ce9-444c-46f6-953d-698aa225da13',
      name: 'Unisex Garment-Dyed Heavyweight T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_3debc7d3b8304fe38e1cd1ea638d1895~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_4b29d03576704c0eb87dff664fb96959~mv2.png',
    },
    {
      id: 'c8d6ac6d-6fe1-46c4-85d7-dad76a5c1098',
      name: 'Retro Trucker Hat',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_0d7a820b056a41cd9970f85004fdbd20~mv2.jpg',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_d9bc5a0d4de94940a8a90d40eab970e1~mv2.jpg',
    },
    {
      id: 'e252308a-5e7b-42a1-ab39-33de599575d3',
      name: 'Unisex Tri-Blend T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_5049835875f44d8bb3d1dde95a25e30d~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a920c81669cf467f8adffaee62573bdf~mv2.png',
    },
    {
      id: 'aaa97992-19f6-4cb0-84f3-98fa5ca79c4c',
      name: 'White Glossy Mug',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_e61df83fd3134552b258e6c6eb1af5fb~mv2.jpg',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_31dcf4409819479c9912615090d9af03~mv2.jpg',
    },
    {
      id: '7fb4b65a-2950-4962-9927-09ac05095f0e',
      name: 'Unisex Heavy Blend Hoodie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_de65659f94f340e580671b1bbcd3e9a6~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f572984297534c54bd05a41411350826~mv2.png',
    },
    {
      id: '5a75a21a-3799-4147-b52d-f3890797409f',
      name: 'Cuffed Beanie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_196ebdf953f8489ca0c4afea8c5d873a~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_c60f124be3014e38ac2a1debb2f3b8a7~mv2.jpg',
    },
    {
      id: 'c548b63e-6158-488b-afcb-d9dbd808675f',
      name: 'Classic Snapback',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_6d22047220c14cea86794e30bbc49bbf~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_7f0916ad8bec4328a3e673cdcd34c471~mv2.jpg',
    },
    {
      id: '8aefc449-ef00-4767-815d-108c3bd86e4c',
      name: 'Unisex Premium Sweatshirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_f089bb9cd49a42cabff7bfe3cc3cc842~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_402c87d7651a461a998679da36a1302e~mv2.png',
    },
  ],
  [CategoryKey.MensClothing]: [
    {
      id: 'ed654ce9-444c-46f6-953d-698aa225da13',
      name: 'Unisex Garment-Dyed Heavyweight T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_3debc7d3b8304fe38e1cd1ea638d1895~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_4b29d03576704c0eb87dff664fb96959~mv2.png',
    },
    {
      id: 'e252308a-5e7b-42a1-ab39-33de599575d3',
      name: 'Unisex Tri-Blend T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_5049835875f44d8bb3d1dde95a25e30d~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a920c81669cf467f8adffaee62573bdf~mv2.png',
    },
    {
      id: 'a0bc4f1a-9e16-4518-8731-30d6d2a35776',
      name: 'Unisex 3/4 Sleeve Raglan Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_d35bda5f3efa4aa2953a96048a0afaee~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_ef21d24083114b9fa1f1aa340f27f255~mv2.jpg',
    },
    {
      id: '947ab7ec-043f-4f01-988d-cbf818206f7d',
      name: 'Unisex Basic Softstyle T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_0f07fdceb22a454198b445dec36b4725~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_34392f7882a444cd874f6ce75ad8865d~mv2.png',
    },
    {
      id: '9a40c3e7-a3e7-4bdf-ab82-89ae616d0a69',
      name: 'Unisex Premium Hoodie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_2efddc8e155b41bb9a4a9002fdb2e78f~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_b79557e8000d4ed9890a1df24a23d812~mv2.png',
    },
    {
      id: '8aefc449-ef00-4767-815d-108c3bd86e4c',
      name: 'Unisex Premium Sweatshirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_793010576e1b475cb93235293fc536ad~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_9449e93163dd406eac3f39446e241c6a~mv2.png',
    },
    {
      id: '7fb4b65a-2950-4962-9927-09ac05095f0e',
      name: 'Unisex Heavy Blend Hoodie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_dc0858f2c24d40cfbeb362a9aa62ec0e~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_fbf2cfe1a79a475c9c5bbbccfbfb728c~mv2.png',
    },
    {
      id: '461756f5-117a-4888-aba6-440c59a33647',
      name: 'Unisex Garment-Dyed Tank Top',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_519ead1d72d04148b58ddf5ee5eeb2ea~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_062bd3e63b6f496cbb0b8c1650a5c453~mv2.png',
    },
  ],
  [CategoryKey.WomensClothing]: [
    {
      id: '38d6cffc-e0ef-4141-aff5-c1d0dde9a90d',
      name: `Women's Relaxed T-Shirt`,
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_669e3b5a98e54654a7daa40235df791d~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_122292f39d3b4bfeb4b7b12a29eba806~mv2.png',
    },
    {
      id: '2489be45-5fca-493c-b7c6-c97d52e90f84',
      name: `Women's Crop Top`,
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_d31b432eb8ec49f19c8ed4d1384900df~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_22a0f9a1e09a4d98b1a21973049f7c96~mv2.png',
    },
    {
      id: '6e62e253-16c6-42ea-8a88-ded477990d9b',
      name: 'Unisex Pigment-Dyed Sweatpants',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_aadf12c8b90d4901b723132d880b4811~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_02ed74065e7b4297b5b2fee20d059696~mv2.jpg',
    },
    {
      id: '522f51f5-b8d3-48d9-b956-bda04ae8c686',
      name: 'Unisex Organic Cotton T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_de6d86448e1143e08f87b588372e7245~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_0af39df010524ba5a16c5753dbdb50c7~mv2.png',
    },
    {
      id: '3b844af8-d9be-451b-b0f9-c75de72b633b',
      name: 'Unisex Fleece Sweatpants',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_74f636b635254306ad0892b3660415a5~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_85f9c2952e464b0793af40be0896fd64~mv2.jpg',
    },
    {
      id: '1aac21ce-0533-4256-9a0e-da07f957f3a7',
      name: 'Unisex Staple T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_558e2994ad1848edbcef547e59735260~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a4842cd2a7fd49cf9e2d4fbd15433b11~mv2.png',
    },
    {
      id: '461756f5-117a-4888-aba6-440c59a33647',
      name: 'Unisex Garment-Dyed Tank Top',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_9fe995501b0c43f5b9a2e6b4619d800e~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_c2201bdc57ed478caa79f969256d74a5~mv2.png',
    },
    {
      id: '0984374e-925c-430d-9d9f-07efed4f97f3',
      name: 'Unisex Organic Oversized High Neck T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_8f490edb6d88446baebf1dc58401c44c~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_4704ff0eab9b4216b14f1b668411b88d~mv2.png',
    },
  ],
  [CategoryKey.KidsClothing]: [
    {
      id: 'c564d62e-12f3-40b5-a24c-117e1cdcca82',
      name: 'Baby Short Sleeve One Piece',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_35cc97733c764253a9811d05db0badd5~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_838aa111d8de4c71ba336d07eea4b06a~mv2.png',
    },
    {
      id: 'ca556744-c38d-4ae1-b415-f10971cffb91',
      name: 'Youth Heavy Blend Hoodie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_937fa2265932493ba19268a9feb63e9c~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a6a1d5b062b34a59bc1f9f03da9e10e1~mv2.png',
    },
    {
      id: 'b7cf632a-050c-4ca2-971f-0ccabee653e8',
      name: 'Youth Long Sleeve Tee',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_66cce6018be0497a8540225e553956c4~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_5d3a1da55a8b4e149f219389ac0918a0~mv2.png',
    },
    {
      id: '7b7fffc5-c912-4e32-8c6d-1fb24dac7c1d',
      name: 'Kids Fleece Hoodie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_78bf786d71bb4b008940c8c02b7083c8~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_1fc74e31cc2f45d3be1c7aaf1d58ffa3~mv2.png',
    },
    {
      id: '66fbc49d-a009-483e-82ea-1912b4ae99e6',
      name: 'Organic Cotton Kids T-Shirt',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_a9b11c66ca7e4c3ca1628386bcd7574e~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_136a5285715248b59d15bd3836dd9615~mv2.png',
    },
    {
      id: 'fd688f1d-bf76-436d-82fb-7012c69a47a4',
      name: 'Youth Classic Tee',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_6709a7016a224c31b455c8b1dcafd35d~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_314faa3e6ecd4e2ab1bff1b323b3fc7b~mv2.png',
    },
    {
      id: 'b1d73575-595c-4375-96ab-fc7bacaf9d41',
      name: 'Youth Staple Tee',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_0ac884f44e5d4b49888ec62321d3b98b~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_478c8cad00a449c58b6f2770fe0aff19~mv2.png',
    },
    {
      id: '683ecb2a-e3b8-4c5e-a42a-1402c48e1496',
      name: 'Baby Staple Tee',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_0d65788dcb3847e49543c182f28d26a7~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_51112daed565489a92ae06450642a6f8~mv2.png',
    },
  ],
  [CategoryKey.Hats]: [
    {
      id: '5a75a21a-3799-4147-b52d-f3890797409f',
      name: 'Cuffed Beanie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_196ebdf953f8489ca0c4afea8c5d873a~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_c60f124be3014e38ac2a1debb2f3b8a7~mv2.jpg',
    },
    {
      id: 'de8f9cc4-ad23-46de-8ec0-74c14f114551',
      name: 'Foam Trucker Hat',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_3f94c143fc8b4f79bca85024e2bb5d90~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_bab53c75501445cda39d2bde069df77e~mv2.png',
    },
    {
      id: '9c76ac98-6392-43fe-a515-39691a65172c',
      name: 'Closed-Back Structured Cap',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_f072b8fb4ee84f958199ac061ff82bfb~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_b6449dfd1688436c89c730d86447feb5~mv2.png',
    },
    {
      id: '88ab4cb5-2f5b-4da4-bc90-0bf6dc2c7ec2',
      name: '5 Panel Trucker Cap',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_bcb5df59a4fa4bb19d523bd0741df7e9~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_be2589082b894ae79460c9b0e707450d~mv2.png',
    },
    {
      id: '70f6a177-dae9-4384-ae64-65c9efbf3242',
      name: 'Classic Dad Hat',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_7dc272df9f3e441a98c119148a0119d2~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_97b047b2ff294dc4bdb42b2e6c4a00c5~mv2.png',
    },
    {
      id: '3ce3061c-c5b9-44c4-9445-25cea5e34275',
      name: 'Knit Beanie',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_32cb91b2468341e9b4497bd2da255f9c~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_44158300ced5406e90b6c325f205f03f~mv2.png',
    },
    {
      id: 'c8d6ac6d-6fe1-46c4-85d7-dad76a5c1098',
      name: 'Retro Trucker Hat',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_0d7a820b056a41cd9970f85004fdbd20~mv2.jpg',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_d9bc5a0d4de94940a8a90d40eab970e1~mv2.jpg',
    },
    {
      id: '50f49599-c413-404c-81e7-413636b588b8',
      name: 'Organic Bucket Hat',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_ff6b63a5a813469099193b71ed0273e2~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f919d6a4ec684dda94d46ebf7cfb5725~mv2.png',
    },
  ],
  [CategoryKey.Accessories]: [
    {
      id: 'ff512494-d6e9-4841-9c6f-af22f412834c',
      name: 'Sublimation Socks',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_e6deb78a2371488ea06bfd7fb9b7ad81~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f91c9b9bc7fc4fb8b874fef43ef97dbb~mv2.png',
    },
    {
      id: 'eff381c2-c006-41c7-aaf9-988e1b5ac85b',
      name: 'Embroidered Patches',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_4817ba2044c04157a5e82ad93df50819~mv2.webp',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_8d668aa0fa6f41599d9b1d3952e7254e~mv2.png',
    },
    {
      id: '9ee267d6-4e0d-40c6-ad84-1d008d02ea0d',
      name: 'Snap Case for Samsung®',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_8fcb961b31144d74b9f6f71dc1480690~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_7b70fcce7e9247ba8f809d6b2f66e9cb~mv2.png',
    },
    {
      id: '828bcbd2-4c9d-45e3-8eb0-e6eda3aae15f',
      name: 'Black Foot Sublimated Socks',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_c5e5635d5ef543f8bd21674911b802b4~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_7d6e6fce972b449c9361be316cbfffe0~mv2.png',
    },
    {
      id: '3df91903-c68d-4b0c-a53d-5679c93e8f28',
      name: 'Rubber Case for AirPods®',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_08ece9f03c1f488bb7e755b4d74686d6~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_768f0a4efe0a48f7b9234ba701549703~mv2.png',
    },
    {
      id: '0b8bd717-b571-4116-beaf-f36351e0f837',
      name: 'Embroidered Crew Socks',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_8418d71939f04c00adc53df3ef664889~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_d1eeb46a0f334892ac342b5c6614659f~mv2.png',
    },
    {
      id: '041fe528-0cef-45bf-9b53-98d977629221',
      name: 'Can Cooler',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_a0b47b84a4344d5cb755c916073842ab~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_2ff285de48fc48cab13c7bbc87ba7b4e~mv2.png',
    },
    {
      id: '0997cf22-26d4-434c-9f5f-eb80440ab55c',
      name: 'All-Over Print Case for AirPods',
      imageUrl: 'https://static.wixstatic.com/media/cd21d3_4ccf561f82364d09a8b9aded5d17709b~mv2.png',
      mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_8330b87a3e0e4d5f92f537444ee392ba~mv2.png',
    },
  ],
};
